import React, {useCallback, useEffect, useMemo, useState} from "react";
import Pagination from "../ui/pagination/Pagination";
import Input from "../ui/common/Input";
import Select from "../ui/select/Select";
import ABTestsFilters from "./AbTestsFilters";
import {DateTime} from "luxon";
import { useDebounce } from "../../customHooks/useDebounce";


import { fetchTestArchive, fetchTestArchiveCSV } from "../../store/slices/abTests";
import { useAppDispatch } from "../../store";
import "./AbTestsFiltering.scss"

type AbTestsFilteringProps = {
    defaultDaysPerod : number
    rowsCount: any
};

const AbTestsFiltering = ({
    defaultDaysPerod,
    rowsCount
}: AbTestsFilteringProps) => {
    
    const [dateRangeStartParam, setDateRangeStartParam] = useState();
    const [dateRangeEndParam, setDateRangeEndParam] = useState();

    const [sectionsParam, setSectionsParam] = useState([]);
    const [paidStatusParam, setPaidStatusParam] = useState();
    const [typeParam, setTypeParam] = useState();
    const [authorsParam, setAuthorsParam] = useState([]);

    const [searchParam, setSearchParam] = useState("");
    const [pageParam, setPageParam] = useState(1);
    const [pageLimitParam, setPageLimitParam] = useState(10);

    const [paginationCountCache, setPaginationCountCache] = useState(0)


    const [loadingFilterParamsFromUrl, setLoadingFilterParamsFromUrl] = useState(true);
    const [loadingSearchAndPaginationParamsFromUrl, setloadingSearchAndPaginationParamsFromUrl] = useState(true);


    const dispatch = useAppDispatch();

    const debouncedSearchValue = useDebounce(searchParam, 700);

    const updateFiltersInURL = useCallback((dateRange, sections, paidStatus, type, authors) => {
        const currentUrl = new URL(window.location.href);
        const searchParams = currentUrl.searchParams;

        if (dateRange.startDate && !dateRange.endDate) {
            const dtStartDate = DateTime.fromJSDate(dateRange.startDate);
            const dateFrom = dtStartDate.toFormat('yyyy-MM-dd'); 

            searchParams.set("date_from", dateFrom);
            searchParams.set("date_to", "");
        }

        // set date range
        if (dateRange.startDate && dateRange.endDate) {
            const dtStartDate = DateTime.fromJSDate(dateRange.startDate);
            const dtEndDate = DateTime.fromJSDate(dateRange.endDate);

            const dateFrom = dtStartDate.toFormat('yyyy-MM-dd'); 
            const dateTo = dtEndDate.toFormat('yyyy-MM-dd');


            searchParams.set("date_from", dateFrom);
            searchParams.set("date_to", dateTo);

            setDateRangeStartParam(dateFrom);
            setDateRangeEndParam(dateTo);
        }
        
        if (sections && sections.length > 0) {
            const sectionNames = sections.map(sect => {
                return sect.value.slice(1);
            })
            
            searchParams.set("sections", sectionNames);
            setSectionsParam(sectionNames);

        } else if (sections.length === 0) {
            searchParams.set("sections", "");
            setSectionsParam([])
        }

        if (paidStatus) {

            searchParams.set("paid_status", paidStatus);
            setPaidStatusParam(paidStatus);
        }

        if (type) {
            searchParams.set("type", type);
            setTypeParam(type)
        }

        if (authors && authors.length > 0) {
            const authorsNames = authors.map(auth => {
                return auth?.value;
            })
            searchParams.set("authors", authorsNames);
            setAuthorsParam(authorsNames)
        } else {
            searchParams.set("authors", "");
            setAuthorsParam([])
        }
        // updateFilteringFilters(dateRange.startDate, dateRange.endDate, sections, paidStatus, type, authors )


        window.history.pushState({}, '', currentUrl);
    },[]) 


    const getUrlParamsForSearchAndPagination = () => {
        const urlParams = new URLSearchParams(window.location.search);

        const searchTerm = urlParams.get("search");
        const page = urlParams.get("page");
        const limit = urlParams.get("limit");

        if (searchTerm) {
            setSearchParam(searchTerm)
        }

        if (page) {
            setPageParam(parseInt(page))
        }

        if (limit) {
            setPageLimitParam(parseInt(limit))
        }

        setloadingSearchAndPaginationParamsFromUrl(false);

    }

    useEffect(()=>{
        getUrlParamsForSearchAndPagination();
    },[])

    
    const updateSearchAndPaginationParamsInUrl = useCallback(() => { 
        const currentUrl = new URL(window.location.href);
        const searchParams = currentUrl.searchParams;

        searchParams.set("search", debouncedSearchValue);
        searchParams.set("page", pageParam.toString());
        searchParams.set("limit", pageLimitParam.toString());
        window.history.pushState({}, '', currentUrl);
    }, [debouncedSearchValue, pageLimitParam, pageParam])
    
    


    const handlePageChange = (page) => {
        setPageParam(page);
    }


    useEffect(()=>{
        updateSearchAndPaginationParamsInUrl();
    },[debouncedSearchValue, pageLimitParam, pageParam, updateSearchAndPaginationParamsInUrl])

    const checkIfReadyToFetch = useCallback(() => {

        if (typeParam === undefined || paidStatusParam === undefined || !dateRangeEndParam) return false        
        return true;
    },[typeParam, paidStatusParam, dateRangeEndParam])


    useEffect(()=>{
        if (loadingFilterParamsFromUrl || loadingSearchAndPaginationParamsFromUrl) return;

        let dayFrom = "";
        let dayTo = "";
        const currentUrl = new URL(window.location.href);
        const searchParams = currentUrl.searchParams;

        if (dateRangeStartParam && !dateRangeEndParam) {
            dayFrom = dateRangeStartParam;
            searchParams.set("date_from", dayFrom)
        }

        else if (!dateRangeStartParam || !dateRangeEndParam) {
            const days = defaultDaysPerod;
        
            
            const dateToday = new Date();
            const dateBefore = new Date(dateToday.getTime() - (days * 24 * 60 * 60 * 1000));
    
            
            const dtStartDate = DateTime.fromJSDate(dateBefore);
            const dtEndDate = DateTime.fromJSDate(dateToday);

            dayFrom = dtStartDate.toFormat('yyyy-MM-dd'); 
            dayTo = dtEndDate.toFormat('yyyy-MM-dd');

            searchParams.set("date_from", dayFrom);
            searchParams.set("date_to", dayTo);
        }
        else {
            dayFrom = dateRangeStartParam
            dayTo = dateRangeEndParam

            searchParams.set("date_from", dayFrom);
            searchParams.set("date_to", dayTo);
        }
          window.history.pushState({}, '', currentUrl);

        if (checkIfReadyToFetch()) {
            dispatch(fetchTestArchive(dayFrom, dayTo, sectionsParam.join(","), paidStatusParam, typeParam, authorsParam.join(","), 
                debouncedSearchValue, pageParam, pageLimitParam))
        }
    },
    [
        dateRangeStartParam, dateRangeEndParam, sectionsParam, 
        loadingFilterParamsFromUrl, debouncedSearchValue, pageParam, pageLimitParam,
        authorsParam, defaultDaysPerod, dispatch, loadingSearchAndPaginationParamsFromUrl, paidStatusParam, typeParam, checkIfReadyToFetch
    ])


    const getCSV = () => {
        dispatch(fetchTestArchiveCSV(dateRangeStartParam, dateRangeEndParam, sectionsParam.join(","), paidStatusParam, typeParam, authorsParam.join(","),
            debouncedSearchValue, pageParam, pageLimitParam))
    }
    
    const calculatePagination = useMemo(() => {
        // case if loading
        if (rowsCount === 0) {
            if (paginationCountCache !== 0) {
                return paginationCountCache;
            }
            return 7
        } 
        // case if there are no data
        else if (rowsCount === -1) {
            return 0
        } else {
            const calculated = Math.ceil(rowsCount/pageLimitParam);
            setPaginationCountCache(calculated)
            return calculated;
        }
    },[rowsCount, pageLimitParam, paginationCountCache])

    return (
        <div className="ab-tests-filtering-wrapper">
            <div className="ab-tests-filters">
               
                <div className="ab-tests-filters-wrapper">
                    <ABTestsFilters 
                        updateFiltersInURL={updateFiltersInURL}
                        loadingFilterParamsFromUrl={loadingFilterParamsFromUrl}
                        setLoadingFilterParamsFromUrl={setLoadingFilterParamsFromUrl}
                        setPageParam={setPageParam}
                        getCSV={getCSV}
                    />
                </div>
            </div>

            <div className="ab-tests-filtering">

                <div style={{display: "flex", alignItems: "center", marginLeft : 0}}>
                    <Input
                        placeholder={"Search by title"}
                        value={searchParam}
                        onChange={(e) => {
                            setSearchParam(e.target.value);
                            setPageParam(1);
                        }}
                    />
                </div>
            
                {
                    calculatePagination !== 0 && 
                    <Pagination 
                        totalPages={calculatePagination} 
                        selectedPage={pageParam} 
                        setSelectedPage={handlePageChange} 
                    />
                }
                
                <div className="table-entries-number">
                    Showing{" "}
                    <Select
                    rounded
                    options={[10,20,50,100]}
                    selectedOption={pageLimitParam}
                    setSelectedOption={(option) => {
                        setPageLimitParam(option);
                        setPageParam(1);
                    }}
                    />{" "}
                    entries
                </div>
            </div>
        </div>
  );
};

export default AbTestsFiltering;